import React, { useState, useEffect } from 'react';
import {
	Box,
	HStack,
	Text,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Spinner,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuDivider,
	Tag,
	Button,
	Icon,
	Wrap,
	WrapItem,
} from '@chakra-ui/react'
import CustomModal from '../../components/CustomModal'
import SelectedChannels from '../../components/SelectedChannels'
import PageLoader from '../../components/Loader/PageLoader';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';
import { LuChevronDown, LuImage } from 'react-icons/lu'
import { fetchWrapper } from '../../helpers';
import Create from './Create';
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import KeysCell from './KeysCell';

function List() {
	//
	const [list, setList] = useState([])
	const [statusFilter, setStatusFilter] = useState('active')

	const [loading, setLoading] = useState(false);
	const { isOpen, onOpen, onClose } = useDisclosure();

	const [isOpenEdit, setIsOpenEdit] = useState(false)
	const [rs, setrs] = useState({})
	const [uploadingImageIds, setUploadingImageIds] = useState({});

	const meClose = () => {
		setIsOpenEdit(false);
		onClose();
	}

	useEffect(() => {
		loadList();
	}, [])

	const loadList = async () => {
		setLoading(true)
		const url = `${process.env.REACT_APP_API_URL}/customer/list-all`;
		const data = await fetchWrapper.get(url)
		setList(data.data);
		setLoading(false)
	}

	const meEdit = (rs) => {
		setIsOpenEdit(true);
		setrs(rs)
		onOpen()
		// setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
	}

	 
  

	// const meEditRate = (rs) => {
	// 	setIsOpenEdit(true);
	// 	setModalEditView(<EditRate meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
	// }

	// const meAddBalance = (rs) => {
	// 	setIsOpenEdit(true);
	// 	setModelHeader('Add Balance')
	// 	setModalEditView(<AddBalance meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
	// }

	// const meCloseEdit = () => {

	// 	setIsOpenEdit(false);

	// }

	const GenerateKey = async (rs) => {
		let data = {
			api_key: uuidv4(),
			id: rs.id

		}


		const url = `${process.env.REACT_APP_API_URL}/customer/update`;
		await fetchWrapper.post(url, data)
		loadList();

	}
	const GenerateSDKKey = async (rs) => {
		let data = {
			sdk_key: uuidv4(),
			id: rs.id

		}


		const url = `${process.env.REACT_APP_API_URL}/customer/update`;
		await fetchWrapper.post(url, data)
		loadList();

	}


	const meActive = async (rs) => {
		const data = {
			status_id: rs.status_id === 1 ? 0 : 1,
			id: rs.id
		}

		const url = `${process.env.REACT_APP_API_URL}/customer/update`;
		await fetchWrapper.post(url, data)
		loadList();

	}
	const handleUploadImage = async (e, rs) => {
		const file = e.currentTarget.files[0];

		const MAX_FILE_SIZE = 2 * 1024 * 1024;
		if (!file) return;
		if (file.size > MAX_FILE_SIZE) {
			return toast.error("File size exceeds 2MB limit.");
		}

		const imageDimensions = await new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = (event) => {
				const img = new Image();
				img.onload = () => {
					resolve({ width: img.width, height: img.height });
				};
				img.onerror = reject;
				img.src = event.target.result;
			};
			reader.onerror = reject;
			reader.readAsDataURL(file);
		});

		if (imageDimensions.width !== 120 || imageDimensions.height !== 120) {
			return toast.error("Image must be exactly 120x120 pixels.");
		}

		const formData = new FormData();
		formData.append("id", rs.id);
		formData.append("logo", file);

		// Start loading for this customer
		setUploadingImageIds(prev => ({ ...prev, [rs.id]: true }));

		try {
			const reader = new FileReader();
			// r
			reader.readAsDataURL(file);

			await fetchWrapper.upload(`${process.env.REACT_APP_API_URL}/customer/update-logo`, formData);

			// ✅ Reload list to reflect updated logo path
			await loadList();
		} catch (error) {
			console.error("Error uploading image:", error);
		} finally {
			// Stop loading for this customer
			setUploadingImageIds(prev => ({ ...prev, [rs.id]: false }));
		}
	};


	const filteredList = list.filter(rs =>
		statusFilter === 'active' ? rs.status_id === 1 : statusFilter === 'inactive' ? rs.status_id === 0 : rs.status_id === 2
	);

	return (
		<>
			<PageLoader isLoading={loading} />
			<BoxWrapper>

				<HStack justifyContent="space-between" mb={6} align="flex-start">
					<Box>
						<Text fontSize="22px" fontWeight="700" color="#111827" my="0px" fontFamily="'Open Sans', sans-serif" letterSpacing="-0.01em">Customers</Text>
						<Text fontSize="13px" color="gray.500" mt="2px">Manage customer accounts and their configurations</Text>
					</Box>
					<Box>
						<CustomModal
							size='3xl'
							showModalButtonText="+ Add Customer"
							modalHeader="Add Customer"
							isOpen={isOpen}
							onClose={meClose}
							onOpen={onOpen}
							modalBody={<Create meClose={meClose} loadList={loadList} isOpenEdit={isOpenEdit} rs={rs} />}
						/>
					</Box>
				</HStack>

				<HStack spacing={0} bg="#f1f5f9" p="1" borderRadius="full" display="inline-flex" mb={4}>
					<Button
						size="sm"
						variant="unstyled"
						px={4}
						h="32px"
						borderRadius="full"
						bg={statusFilter === 'active' ? 'white' : 'transparent'}
						boxShadow={statusFilter === 'active' ? 'sm' : 'none'}
						fontWeight={statusFilter === 'active' ? '600' : '400'}
						color={statusFilter === 'active' ? '#111827' : 'gray.500'}
						onClick={() => setStatusFilter('active')}
					>
						Active
					</Button>
					<Button
						size="sm"
						variant="unstyled"
						px={4}
						h="32px"
						borderRadius="full"
						bg={statusFilter === 'inactive' ? 'white' : 'transparent'}
						boxShadow={statusFilter === 'inactive' ? 'sm' : 'none'}
						fontWeight={statusFilter === 'inactive' ? '600' : '400'}
						color={statusFilter === 'inactive' ? '#111827' : 'gray.500'}
						onClick={() => setStatusFilter('inactive')}
					>
						Inactive
					</Button>
					<Button
						size="sm"
						variant="unstyled"
						px={4}
						h="32px"
						borderRadius="full"
						bg={statusFilter === 'draft' ? 'white' : 'transparent'}
						boxShadow={statusFilter === 'draft' ? 'sm' : 'none'}
						fontWeight={statusFilter === 'draft' ? '600' : '400'}
						color={statusFilter === 'draft' ? '#111827' : 'gray.500'}
						onClick={() => setStatusFilter('draft')}
					>
						Draft
					</Button>
				</HStack>

				<div className="table_section">
					<TableContainer width="100%">
						<Table variant='simple' width="100%">
							<Thead>
								<Tr>
									<Th></Th>
									<Th>Customer Name</Th>
									<Th>Contact Person</Th>
									<Th>Contact No</Th>
									<Th>Customer Channel</Th>
									<Th>Server IP</Th>
									<Th>Keys</Th>
									<Th>Sale Contract</Th>
									<Th>Status</Th>
									<Th></Th>





								</Tr>
							</Thead>

							<Tbody fontSize="14px">
								{filteredList.map((rs, index) => {
									return (

										<Tr key={rs?.id || index}>
										
											<Td>
												<Box
													border="1.5px dashed #d1d5db"
													borderRadius="8px"
													height="44px"
													width="44px"
													display="flex"
													alignItems="center"
													justifyContent="center"
													cursor="pointer"
													position="relative"
													onClick={() => document.getElementById(`fileInput-${rs.id}`).click()}
													bg="#f8fafc"
													color="gray.400"
													_hover={{ bg: "#eff6ff", borderColor: "#2563eb", color: "#2563eb" }}
													transition="all 0.2s"
												>
													{uploadingImageIds[rs.id] ? (
														<Spinner size="sm" color="blue.500" />
													) : rs.logo ? (
														<img
															src={`${process.env.REACT_APP_API_URL}${rs.logo}`}
															alt="Logo"
															style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', height: '100%', zIndex: 1 }}
														/>
													) : (
														<LuImage />
													)}
													<input
														type="file"
														accept="image/*"
														id={`fileInput-${rs.id}`}
														style={{ display: 'none' }}
														onChange={(event => handleUploadImage(event, rs))}
													/>
												</Box>
											</Td>
											<Td>
												<Link to={`/customer-detail/${rs.id}`} state={{ id: rs.id }}>
													<Text fontWeight="600" color="#1e4ed8" fontSize="13px">
														{rs.business_name}
													</Text>
												</Link>
												<a
													href={`https://${rs.domain_name}.${process.env.REACT_APP_DOMAIN}`}
													target='_blank'
													rel='noreferrer'
												>
													<Text fontSize="11px" color="gray.400" style={{ textWrap: "wrap" }} maxW="200px" mt="1px">
														{`${rs.domain_name}.${process.env.REACT_APP_DOMAIN}`}
													</Text>
												</a>
											</Td>
											<Td color="#374151">{rs.name}</Td>
											<Td color="#374151">{rs.contact_no}</Td>
											<Td><SelectedChannels channel_list={rs?.customer_channel} /></Td>
											<Td maxW="220px">
												{rs.server_ip ? (
													<Wrap spacing="4px">
														{rs.server_ip.split(',').map((ip, ipIndex) => (
															<WrapItem key={ipIndex}>
																<Tag bg="gray.100" color="#374151" borderRadius="4px" px={2} py="2px" fontWeight="500" fontSize="11px" fontFamily="monospace">
																	{ip.trim()}
																</Tag>
															</WrapItem>
														))}
													</Wrap>
												) : (
													<Text color="gray.300" fontSize="13px">—</Text>
												)}
											</Td>

											<KeysCell key={`keys-${rs.id}`} rs={rs} loadList={loadList} />

											<Td>
												{rs?.SaleChannel?.name
													? <Tag bg="#2563eb" color={"white"} borderRadius="4px" px={2} py="2px" fontWeight="500">{rs.SaleChannel.name}</Tag>
													: <Text color="gray.300" fontSize="13px">—</Text>
												}
											</Td>

											<Td>
												<Tag
													bg={rs.status_id === 1 ? "#00a63e" : rs.status_id === 2 ? "#6b7280" : "#ef4444"}
													borderRadius="4px"
													color="white"
													px={2}
													py="2px"
													fontWeight="500"
													fontSize="11px"
												>
													{rs.status_id === 1 ? "Active" : rs.status_id === 2 ? "Draft" : "Inactive"}
												</Tag>
											</Td>

											<Td>
												<Menu>
													<MenuButton
														as={Button}
														size="xs"
														variant="outline"
														rightIcon={<Icon as={LuChevronDown} />}
														borderColor="#d1d5db"
														color="#374151"
														fontWeight="500"
														_hover={{ bg: "#f3f4f6" }}
													>
														Action
													</MenuButton>
													<MenuList minWidth="160px">
														<MenuItem fontSize="13px" onClick={() => meEdit(rs)}>Edit</MenuItem>
														<MenuDivider />
														<MenuItem fontSize="13px" onClick={() => meActive(rs)}>
															{rs.status_id === 1 ? "Mark as Inactive" : "Mark as Active"}
														</MenuItem>
													</MenuList>
												</Menu>
											</Td>

										</Tr>

									)
								})}





							</Tbody>


						</Table>

					</TableContainer>
				</div>
			</BoxWrapper>
		</>
	)
}

export default List;